/* eslint-disable import/prefer-default-export */

/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
export * from 'SourceComponent/Header/Header.config';
export const STORE_SWITCHER = 'storeSwitcher';
export const LANG_SWITCHER = 'langSwitcher';
export const VEHICLE_GARAGE = 'vehicleGarage';
export const PDP = 'pdp';
export const POPUP = 'popup';
export const CATEGORY = 'category';
export const CUSTOMER_ACCOUNT = 'customer_account';
export const CUSTOMER_SUB_ACCOUNT = 'customer_sub_account';
export const CUSTOMER_ACCOUNT_PAGE = 'customer_account_page';
export const CUSTOMER_WISHLIST = 'wishlist';
export const HOME_PAGE = 'home';
export const MENU = 'menu';
export const MENU_SUBCATEGORY = 'menu_subcategory';
export const SEARCH = 'search';
export const FILTER = 'filter';
export const CART = 'cart';
export const CART_OVERLAY = 'cart_overlay';
export const CART_EDITING = 'cart_editing';
export const CHECKOUT = 'checkout';
export const CHECKOUT_SUCCESS = 'checkout_success';
export const CHECKOUT_ACCOUNT = 'checkout_account';
export const CMS_PAGE = 'cms-page';
export const MY_ACCOUNT = 'my-account';
export const NO_MATCH = 'no-match';
export const CONTACT_US = 'contact-us';
export const PRODUCT_COMPARE = 'product-compare';
export const LOGIN = 'account/login';
export const REGISTER = 'account/create';
export const FORGOT_PASSWORD = 'account/forgotpassword';
